'use client';
import Phone from '@/app/_components/ui/icons/Phone.svg';
import WhatsAppGreen from '@/app/_components/ui/icons/WhatsAppGreen.svg';
import Copy from '@/app/_components/ui/icons/Copy.svg';
import Linkedin from '@/app/_components/ui/icons/Linkedin.svg';
import Pinterest from '@/app/_components/ui/icons/Pinterest.svg';
import Youtube from '@/app/_components/ui/icons/Youtube.svg';
import Aparat from '@/app/_components/ui/icons/Aparat.svg';
import Instagram from '@/app/_components/ui/icons/Instagram.svg';
import Telegram from '@/app/_components/ui/icons/Telegram.svg';
import Link from 'next/link';
import Image from 'next/image';
import FooterMenu from './FooterMenu';
import { data } from '@/app/_libs/utils/constants/FooterData';
import { useRef, useState } from 'react';
import NewsLetter from './NewsLetter';

export default function Footer() {
  const couponCode = useRef(null);
  const [copySuccess, setCopySuccess] = useState('');
  const copyToClipboard = async (e) => {
    const copyMe = couponCode.current.innerText;
    try {
      await navigator.clipboard.writeText(copyMe);
      setCopySuccess('کپی شد');
    } catch (err) {
      setCopySuccess('');
    }
  };
  return (
    <footer id="footer" className=" bg-[#FBFBFB] pt-9">
      <div className="container">
        <div className="mb-6">
          <div className="lg:grid grid-cols-12">
            <div className="col-span-5">
              <div className=" mb-5 relative flex">
                <div className="pl-5 ">
                  <Image
                    src="/images/barghchi-logo.svg"
                    width={145}
                    height={46}
                    alt="فروشگاه برقچی"
                    className="max-w-[100px] md:max-w-[200px] relative z-10 "
                  />
                </div>

                <div className="border-r border-light-gray-300 pr-5">
                  <p className="footr-time font-bold text-xs md:text-base">
                    پاسخ گوی شما هستیم
                  </p>
                  <p className="text-sm mt-2">
                    از 9 صبح تا 18 عصر بجز روزهای تعطیل
                  </p>
                </div>
              </div>
              <div className="footer-phone mt-12 flex  text-xs md:text-base  ml-2.5 ">
                <div className="flex items-start ml-12">
                  <div className="bg-color-primary p-1 rounded-full">
                    <Phone />
                  </div>
                  <div className="pr-2  font-bold">
                    تلفن:
                    <Link href="tel:02135000020" className="block">
                      021-35000020
                    </Link>
                    <Link href="tel:02191003520" className="block">
                      021-91003520
                    </Link>
                  </div>
                </div>
                <div className="flex">
                  <div className="">
                    <WhatsAppGreen />
                  </div>
                  <div className="pr-2 font-bold">
                    چت با کارشناسان
                    <Link
                      href="https://api.whatsapp.com/send?phone=989393455474"
                      target="_blank"
                      className="block"
                    >
                      ۰۹۳۹۳۴۵۵۴۷۴
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-span-7">
              <div className="footer-top flex flex-wrap py-8 lg:pt-0">
                <div className="w-full ">
                  <div className="footer-menus-wrap lg:flex flex-wrap ">
                    {data.map((menu, index) => (
                      <div key={index} className="w-full lg:w-1/3 pb-6">
                        <FooterMenu menu={menu} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="lg:grid grid-cols-12">
            <div className="footer-discounts col-span-5 ">
              <div className="font-bold">کدهای تخفیف برقچی</div>

              <div className="flex mt-8">
                <div className="cardWrap flex w-48 bg-ocean-blue rounded-md justify-between ml-4">
                  <div className="card cardLeft p-2">
                    <div className="coupon-desc-wrap">
                      <div className="coupon-title text-sm text-white text-center">
                        <p ref={couponCode}>FkrS2Bqv</p>
                        <p className="text-xs">تخفیف اولین خرید</p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="card cardRight p-2 flex items-center border-dashed border-r-2 border-white"
                    onClick={copyToClipboard}
                  >
                    <div className="coupon-value px-2 cursor-pointer">
                      {copySuccess ? (
                        <span className="text-tiny text-white">
                          {copySuccess}
                        </span>
                      ) : (
                        <Copy fill="#fff" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full md:flex col-span-7 border-t justify-between border-light-gray-100 mt-10  md:border-none pt-8 md:pt-0 ">
              <div className="newsletter-form">
                <p className="text-sm mb-2.5 font-bold">
                  از جدیدترین تخفیف ها با خبر شوید:
                </p>
                <div className="">
                  <NewsLetter />
                </div>
              </div>
              <div>
                <div className="social-media mt-8 md:mt-0 md:max-w-[200px] flex itemc-center flex-wrap justify-between p-2.5 w-96 max-w-full items-center">
                  <div className="md:basis-2/6 md:mb-4">
                    <Link
                      href="https://www.linkedin.com/company/barghchi/mycompany/"
                      className=" w-10 h-10 flex justify-center items-center bg-light-gray-150 rounded-md"
                      target="_blank"
                    >
                      <Linkedin />
                    </Link>
                  </div>
                  <div className="md:basis-2/6 md:mb-4 ">
                    <Link
                      href="https://www.pinterest.com/barghchiteam/"
                      className=" w-10 h-10 flex justify-center items-center bg-light-gray-150 rounded-md"
                      target="_blank"
                    >
                      <Pinterest />
                    </Link>
                  </div>
                  <div className="md:basis-2/6 md:mb-4 ">
                    <Link
                      href="https://www.youtube.com/channel/UCip2JyoxkW4O_sjUeKeuarw"
                      className=" w-10 h-10 flex justify-center items-center bg-light-gray-150 rounded-md"
                      target="_blank"
                    >
                      <Youtube />
                    </Link>
                  </div>
                  <div className="md:basis-2/6 ">
                    <Link
                      href="https://www.aparat.com/barghchi/"
                      className="w-10 h-10 flex justify-center items-center bg-light-gray-150 rounded-md"
                      target="_blank"
                    >
                      <Aparat />
                    </Link>
                  </div>
                  <div className="md:basis-2/6 ">
                    <Link
                      href="https://instagram.com/barghchigroup?igshid=MzRlODBiNWFlZA=="
                      className="w-10 h-10 flex justify-center items-center bg-light-gray-150 rounded-md"
                      target="_blank"
                    >
                      <Instagram />
                    </Link>
                  </div>
                  <div className="md:basis-2/6 ">
                    <Link
                      href="https://t.me/barghchi_online"
                      className="w-10 h-10 flex justify-center items-center bg-light-gray-150 rounded-md"
                      target="_blank"
                    >
                      <Telegram />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-2 pb-4">
          <div className="w-full border-t border-light-gray-200"></div>
        </div>
        <div className="footer-bottom  -mx-4  flex pb-7 flex-wrap">
          <div className="w-fulll md:w-7/12 my-4 px-4">
            <p className="footer-about text-xs md:text-sm  text-light-gray-800 mb-2.5 text-justify leading-8">
              فروشگاه اینترنتی برقچی در زمینه تخصصی تجهیزات برقی، شبکه پسیو،
              اکتیو و فیبرنوری و ملزومات مرتبط فعالیت خود را به عنوان مجموعه ای
              پیش رو در حوزه کسب و کارهای اینترنتی جهت ارائه محصولات از تولید
              کنندگان، وارد کنندگان و عمده فروشان به مصرف کنندگان نهایی آغاز
              کرده است. تلاش تیم برقچی همواره برای ایجاد بستری متفاوت و کارآمد
              در حوزه تجارت الکترونیک برای خریداران و فروشندگان بوده است.
            </p>
          </div>
          <div className="w-full md:w-5/12 my-4 px-4">
            <div className="certificates-wrap flex flex-wrap">
              <div className="footer-certificate flex-1 m-2.5 mb-0 border border-light-gray-300 rounded-xl flex  p-1">
                <a
                  referrerPolicy="origin"
                  target="_blank"
                  href="https://trustseal.enamad.ir/?id=119231&amp;Code=GYGBQou8Ct2QFJuALWBN"
                >
                  <img
                    referrerPolicy="origin"
                    src="/images/enamad.png?id=119231&amp;Code=GYGBQou8Ct2QFJuALWBN"
                    alt=""
                    id="GYGBQou8Ct2QFJuALWBN"
                    loading="lazy"
                  />
                </a>
              </div>
              <div className="footer-certificate flex-1 m-2.5 mb-0 border border-light-gray-300 rounded-xl flex  p-1">
                <Link
                  href="https://tehran.irannsr.org/fa/real_persones/2495530/swd_id/104366/%D8%A7%D8%B9%D8%B6%D8%A7-%D9%85%D8%B4%D8%A7%D9%88%D8%B1%D8%A7%D9%86-%D8%AD%D9%82%DB%8C%D9%82%DB%8C-%D8%A7%D9%85%DB%8C%D9%86-%DA%A9%D8%B1%DB%8C%D9%85%DB%8C.html"
                  target="_blank"
                >
                  <Image
                    width="130"
                    height="130"
                    src={'/images/rayane.webp'}
                    alt="rayane"
                  />
                </Link>
              </div>
              <div className="footer-certificate flex-1 m-2.5 mb-0 border border-light-gray-300 rounded-xl flex  p-1">
                <Link href="https://www.itunion.ir/website/fa/" target="_blank">
                  <Image
                    width="130"
                    height="130"
                    src={'/images/fanavaran-logo.webp'}
                    alt="fanavaran"
                  />
                </Link>
              </div>
              <div className="footer-certificate flex-1 m-2.5 mb-0 border border-light-gray-300 rounded-xl flex  p-1">
                <Link
                  href="https://eanjoman.ir/member/X4Xqaa3YjvyP2yeH4iWGOWXh2"
                  target="_blank"
                >
                  <Image
                    width="130"
                    height="130"
                    src={'/images/karfarmayan.webp'}
                    alt="karfarmayan"
                  />
                </Link>
              </div>
              <div className="footer-certificate justify-center flex-1 m-2.5 mb-0 border border-light-gray-300 rounded-xl flex  p-1">
                <Link
                  href="https://ecunion.ir/verify/barghchi.com?token=39825436163d56c4cc64"
                  target="_blank"
                >
                  <img
                    src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQwIiBoZWlnaHQ9IjM2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoIGQ9Im0xMjAgMjQzbDk0LTU0IDAtMTA5IC05NCA1NCAwIDEwOSAwIDB6IiBmaWxsPSIjODA4Mjg1Ii8+Cgk8cGF0aCBkPSJtMTIwIDI1NGwtMTAzLTYwIDAtMTE5IDEwMy02MCAxMDMgNjAgMCAxMTkgLTEwMyA2MHoiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDo1O3N0cm9rZTojMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjE0IDgwbC05NC01NCAtOTQgNTQgOTQgNTQgOTQtNTR6IiBmaWxsPSIjMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjYgODBsMCAxMDkgOTQgNTQgMC0xMDkgLTk0LTU0IDAgMHoiIGZpbGw9IiM1ODU5NWIiLz4KCTxwYXRoIGQ9Im0xMjAgMTU3bDQ3LTI3IDAtMjMgLTQ3LTI3IC00NyAyNyAwIDU0IDQ3IDI3IDQ3LTI3IiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MTU7c3Ryb2tlOiNmZmYiLz4KCTx0ZXh0IHg9IjE1IiB5PSIzMDAiIGZvbnQtc2l6ZT0iMjVweCIgZm9udC1mYW1pbHk9IidCIFlla2FuJyIgc3R5bGU9ImZpbGw6IzI5Mjk1Mjtmb250LXdlaWdodDpib2xkIj7Yudi22Ygg2KfYqtit2KfYr9uM2Ycg2qnYtNmI2LHbjDwvdGV4dD4KCTx0ZXh0IHg9IjgiIHk9IjM0MyIgZm9udC1zaXplPSIyNXB4IiBmb250LWZhbWlseT0iJ0IgWWVrYW4nIiBzdHlsZT0iZmlsbDojMjkyOTUyO2ZvbnQtd2VpZ2h0OmJvbGQiPtqp2LPYqCDZiCDaqdin2LHZh9in24wg2YXYrNin2LLbjDwvdGV4dD4KPC9zdmc+ "
                    alt="ecuinion"
                    width="40"
                    height="82"
                  />
                </Link>
              </div>
              <div className="footer-certificate flex-1 m-2.5 mb-0 border border-light-gray-300 rounded-xl flex p-1">
                <Link
                  href="https://samandehi.ir/Pages/HomePage.aspx"
                  target="_blank"
                >
                  <Image
                    width="130"
                    height="130"
                    src={'/images/samandehi.webp'}
                    alt="samandehi"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-copyright bg-color-primary text-white text-center p-4 text-sm">
        تمامی حقوق این وبسایت محفوظ و متعلق به barghchi.com می‌باشد. هرگونه
        کپی‌برداری از آن موجب پیگرد قانونی خواهد بود. | © برقچی Barghchi
      </div>
    </footer>
  );
}
